var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bk-bets-list',{attrs:{"data-func":_vm.getBets,"show-user":true}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/clients/client/players/player/bk-bets.vue?vue&type=template&id=2e19e5f0&scoped=true
// module id = Pz8+
// module chunks = 0